import getStore from '../store';
import {
    closeCurrentTimeStreamProject,
    getAsset,
    timeStreamProjectPreviewOpened,
} from 'owa-timestream-store';
import { getProjectPreviewId } from 'owa-timestream-projectmanager';
import { focusAsset } from 'owa-timestream-asset-sdk-actions';
import { mutator } from 'satcheljs';
import {
    finishPanning,
    panDown,
    panLeft,
    panRight,
    panUp,
    panByWheel,
    resetPanAndZoom,
    trackCanvasBounds,
    zoomIn,
    zoomOut,
    zoomByWheel,
} from '../actions';
import getAssetsBoundingRect from '../selectors/getAssetsBoundingRect';
import getCanvasBounds from '../selectors/getCanvasBounds';
import getPanAndZoom from '../selectors/getPanAndZoom';
import getZoom from '../selectors/getZoom';
import { isMac } from 'owa-user-agent';

const macPanConstant = 5;
const panConstant = 25;
const panPixels = isMac() ? macPanConstant : panConstant;
const negativePanPixels = -1 * panPixels;

function setPan({ x, y }: { x: number; y: number }) {
    getStore().pan = { x, y };
}

mutator(timeStreamProjectPreviewOpened, () => {
    // set basic pan to center preview
    getStore().pan = { x: 175, y: 20 };
});

mutator(trackCanvasBounds, ({ top, left, width, height }) => {
    // if the canvas is in a preview, center the assets
    if (!!getProjectPreviewId()) {
        const assetBounds = getAssetsBoundingRect();
        const zoom = getZoom();
        const centeredAssetBoundsX =
            left + (width - Math.abs(assetBounds.left - assetBounds.right) * zoom) / 2;
        const centeredAssetBoundsY =
            top + (height - Math.abs(assetBounds.top - assetBounds.bottom) * zoom) / 2;
        getStore().pan = {
            x: Math.abs(left - centeredAssetBoundsX) - assetBounds.left * zoom,
            y: Math.abs(top - centeredAssetBoundsY) - assetBounds.top * zoom,
        };
    }
});

mutator(closeCurrentTimeStreamProject, () => {
    getStore().pan = { x: 0, y: 0 };
});

mutator(resetPanAndZoom, ({ pan }) => {
    getStore().pan = pan;
});

mutator(zoomIn, setPan);
mutator(zoomOut, setPan);
mutator(zoomByWheel, setPan);
mutator(finishPanning, setPan);

mutator(panLeft, () => {
    getStore().pan.x += 25;
});

mutator(panRight, () => {
    getStore().pan.x -= 25;
});

mutator(panUp, () => {
    getStore().pan.y += 25;
});

mutator(panDown, () => {
    getStore().pan.y -= 25;
});

mutator(panByWheel, ({ deltaX, deltaY }) => {
    if (deltaX) {
        getStore().pan.x += deltaX > 0 ? negativePanPixels : panPixels;
    }
    if (deltaY) {
        getStore().pan.y += deltaY > 0 ? negativePanPixels : panPixels;
    }
});

mutator(focusAsset, ({ projectId, id }) => {
    const { x, y, lastKnownWidth, lastKnownHeight } = getAsset(projectId, id).bounds;
    const { width, height } = getCanvasBounds();
    const { zoom, ...pan } = getPanAndZoom();

    if (
        x + lastKnownWidth < -pan.x / zoom ||
        x > (-pan.x + width) / zoom ||
        y + lastKnownHeight < -pan.y / zoom ||
        y > (-pan.y + height) / zoom
    ) {
        // check to see if focused asset is outside of canvas + pan view before panning
        getStore().pan = { x: -x * zoom + width / 2, y: -y * zoom + height / 2 };
    }
});
